import { useAuth } from '@modules/auth/contexts/Auth'
import { emailRule, requiredRule } from '@utils/rules'
import { CSRF_COOKE_URL } from '@utils/urls'
import { Button, Form, Input, Space, Typography } from 'antd'
import axios from 'axios'
import { useState } from 'react'
import { Link } from 'react-router-dom'

const { Title, Text } = Typography

const LoginPage = () => {
  const { login } = useAuth()

  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [error, setError] = useState<string | undefined>(undefined)

  const onFinish = (values: { email: string; password: string }) => {
    setIsLoading(true)
    setError(undefined)

    axios
      .get(CSRF_COOKE_URL)
      .then(() => {
        login(values.email, values.password).catch(() => {
          setError('Error ... Ensure your credentials are correct.')
        })
      })
      .finally(() => setIsLoading(false))
  }

  return (
    <Space orientation="vertical" className="w-full">
      <Title className="m-0" level={5}>
        Login
      </Title>
      <Form onFinish={onFinish}>
        <Form.Item name="email" rules={[requiredRule(), emailRule()]}>
          <Input
            size="large"
            className="authField"
            placeholder={'Email'}
            autoComplete="email"
          />
        </Form.Item>
        <Form.Item name="password" rules={[requiredRule()]}>
          <Input.Password
            size="large"
            className="authField"
            placeholder={'Password'}
            autoComplete="current-password"
          />
        </Form.Item>

        <Form.Item style={{ marginBottom: 15 }}>
          <Button
            size="large"
            className="w-full"
            type="primary"
            htmlType="submit"
            disabled={isLoading}
            loading={isLoading}
          >
            Login
          </Button>
        </Form.Item>
      </Form>
      <Text>{error}</Text>
      <Space
        style={{ justifyContent: 'center', width: '100%' }}
        orientation="horizontal"
        size={30}
      >
        <Link to={'/auth/forgot-password'}>Forgot password</Link>
      </Space>
    </Space>
  )
}

export default LoginPage
